export default __webpack_public_path__ + "static/media/thumb.380fcb7d.svg";